export const SETH = "SETDEGREES";
export const SETLS = "SETLS";
export const SETA = "SETA";
export const SETDEG = "SETDEG";
export const CHANGEACTIVECOL = "CHANGEACTIVECOL";
export const SETACTIVECOL = "SETACTIVECOL";
export const SETACTIVEWIDTH = "SETACTIVEWIDTH";
export const SETGRADIENTCODE = "SETGRADIENTCODE";
export const REMOVEGRADIENTCOL = "REMOVEGRADIENTCOL";
export const SWITCHORDER = "SWITCHORDER";
export const SETCOLORWIDTH = "SETCOLORWIDTH";
export const UNSETCOLORWIDTH = "UNSETCOLORWIDTH";

export const HSL = "HSL";
export const RGB = "RGB";
